// extracted by mini-css-extract-plugin
module.exports = {"container":"Sidebar_container___c50S"};